import { useEffect, useState } from 'react'
import axios from 'axios'
//COMPONENTES PARTES


//INPORTAÇOES DE ICONES E IMAGENS
import IconChecked from '../../acets/img_icon/checked.svg'


import MenuPainelAdmin from '../partils/AdminMenuPainel'
import IconNoChecked from '../../acets/img_icon/nochecked.svg'
import IconEdit from '../../acets/img_icon/edit.svg'

import TenancyColor from '../midllers/TenancyColor'
import AdminHeader from '../partils/AdminHeader'

export default function AdminPix(){
    //CONGIGURAÇÕES=============================
    const config={
        pageName:'PIX',
        mainstring:'nome',
        url:'/api/pixAPI/',
        url2:'',
        search:'/api/pixAPI/search/',
        urlOptions1:'/api/pixAPI',
        
        params:'',
        messegerError:'ATENÇÃO - Preencha os campos para salvar os dados ;D',
    }
     //INICIANDO CICLO DE ESTADOS
     useEffect(()=>{
        rec();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[])
    //STATES======================================
    const initialValues={ // DEFININDO UMA CONST PARA O STATE INICIAL 
        nome: '',ingredientes:'', quantidade: '',preco_final: '',status: '',validade: '',preco_custo:'', id_produto_categoria: '', id_cardapio:'3'
    }
    const [openNew,setOpenNew]=useState(false)// ABRIR TELA DE CADASTRAR E EDITAR
    const [values, setValues]=useState(initialValues) // INICIANDO UM STATE
    const [data, setData] = useState([])
    const[dataInput,setDataInput]=useState([{"id_produto_categoria":0}])
    
    //FUNÇÕES=====================================
    function rec() {//CARREGAR ESTADOS E ATUALIZAR CICLO DE COMPONENTES
        /*axios.get(config.url).then(resp=>{
            setData(resp.data)})
        axios.get(config.urlOptions1).then(resp=>{
            setDataInput(resp.data)
        })*/
    }
    function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
        const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV filter ou desestruturação
        setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
    }
    function onSubmit(ev){//CADASTRAR NO BANCO DE DADOS, obs refatorado para tirar o if e else e usar o. ternario edit e cadastrar
        ev.preventDefault();
            axios[values.id_produto?'put':'post'](config.url,values).then(()=>{
                setOpenNew(false)
                setValues(initialValues);
                rec();
            })
    }
    const editar = function(id){//
        setOpenNew(true)
        axios.get(config.url + id).then(respp=>{
            setValues(respp.data[0])
            })
    }
    const exclui = function(id){
        axios.delete(config.url + id).then(()=>{
            rec();
            setOpenNew(false)
            setValues(initialValues)
        })
    }
    function onSubmitSearch(ev){//PESQUISA
        ev.preventDefault();
        axios.post(config.search, values).then(respp=>{
            setData(respp.data)       
        })
    }
    //COMPONENTES DE LOOP==============================
    const final = data.map(
        namesString =>
            <div className='w100 h4 row ma5 between linha'  key={namesString.id_produto}> 
                <div className='w5'>{namesString.status===1?<img src={IconChecked}/>:<img src={IconNoChecked}/>}</div>
                <div className='w5 cell-tamanho10'>{namesString.id_produto}</div>
                <div className='w25 cell-tamanho80 fb'>{namesString.nome}</div>
                
                <div className='w10 cell-texto-p c4'>{namesString.quantidade}</div>
                <div className='w10 cell-texto-p c4'>R$: {namesString.preco_custo}</div>
                <div className='w10 cell-texto-p c4'>R$: {namesString.preco_final}</div>
                <div className='w10 cell-texto-p c4'>R$: {String(namesString.preco_final-namesString.preco_custo).substring(0, 5)}</div>
                <div className='w5 cell-texto-p c4'>{namesString.categoria}</div>
                <div className='w10 cell-texto-p c4'>{namesString.validade}</div>
                <div className="w5 h4 row center pp">
                    <b onClick={()=>editar(namesString.id_produto)}> <img src={IconEdit}></img> </b>
                </div>
                <div className='w100 fs08em cell-tamanho cell-margin5 c4'>{namesString.ingredientes}</div>
            </div>
    )
    const optionInput = dataInput.map(repsValues=>
        <option key={repsValues.id_produto_categoria} value={repsValues.id_produto_categoria}>{repsValues.nome_categoria}</option>

    )
    const qr = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAADkCAYAAACIV4iNAAAAAklEQVR4AewaftIAAAw5SURBVO3BQY4cSRLAQDLR//8yV0c/BZCoailm4Wb2B2utKzysta7xsNa6xsNa6xoPa61rPKy1rvGw1rrGw1rrGg9rrWs8rLWu8bDWusbDWusaD2utazysta7xsNa6xsNa6xo/fEjlb6qYVE4qJpWp4kRlqviEylRxojJVnKi8UXGiMlVMKlPFpDJVTConFScqU8Wk8jdVfOJhrXWNh7XWNR7WWtewP/iAylTxTSpTxRsqU8WJylQxqUwVJyp/U8WkMlWcqHxTxRsqn6iYVKaKb1KZKj7xsNa6xsNa6xoPa61r/PDLVN6o+E0qJxWTyonKGxUnKlPFGypTxaTyiYpJZaqYVKaKSeWkYlL5JpU3Kn7Tw1rrGg9rrWs8rLWu8cN/nMpUcVIxqUwqJxUnKicqU8WJyknFicpUMamcVJxUvKFyUvFGxf+Th7XWNR7WWtd4WGtd44f/cxUnFZ9QmSpOVCaVqWJSOVH5pooTlZOKqeINlaliqvh/9rDWusbDWusaD2uta/zwyyr+JpWp4kRlqphUpooTlZOKSeWNijdUTiomlaniDZWp4kRlqphUpopvqrjJw1rrGg9rrWs8rLWu8cOXqfxLFZPKVPGbKiaV36QyVbyhMlVMKlPFpDJVTCpTxTepTBUnKjd7WGtd42GtdY2HtdY1fvhQxX+JyonKico3VXyi4jdVTCpTxScqTio+UfFf8rDWusbDWusaD2uta/zwIZWp4g2VqWJS+ZcqJpWp4qRiUvmEym9SmSpOVL5JZao4qZhUvqniRGWq+MTDWusaD2utazysta7xwy9TOamYVKaKSWWqmFTeqJhUJpWp4jdVnKi8UfFGxUnFpDJV/E0qU8VvUpkqvulhrXWNh7XWNR7WWtewP/iLVKaKE5WpYlKZKk5UpooTlTcqJpVPVEwqU8Wk8kbFJ1Smik+onFRMKicVJypTxaTyRsUnHtZa13hYa13jYa11jR8+pDJVTCpvqEwVJxVvVEwqJxW/qWJSOamYVKaKSWWqOFE5qZgqJpWTikllqphUTiomlROVE5WTiknlmx7WWtd4WGtd42GtdY0fPlQxqUwVk8obKlPFGypTxVTxhspUMalMFZPKpDJVfFPFicpU8U0VJxVvqEwVU8Wk8l/ysNa6xsNa6xoPa61r/PAhlanimyomlaliUpkqTlSmiknlRGWqOKk4UTmpOFF5o2JSOak4qThReaPiDZWpYlK52cNa6xoPa61rPKy1rvHDhypOVKaKSWWqmFROVKaKSWWqeKPiROUTKicVk8pUMam8oTJVnKhMFZPKScWk8obKScUnKiaVSWWq+KaHtdY1HtZa13hYa13jhw+pTBVvVJxUvKEyVUwqU8Wk8ptUTipOKt6omFTeUJkqTipOVKaKSWVSOamYVKaKN1T+pYe11jUe1lrXeFhrXcP+4AMqU8WkclIxqXxTxTepvFExqZxUvKHyTRWfUJkqTlROKiaVv6niRGWq+MTDWusaD2utazysta5hf/ABlZOK36QyVZyoTBUnKicVJyonFScq31QxqZxUTCpTxYnKVDGpvFHx/+xhrXWNh7XWNR7WWtf44csqJpWpYlKZKiaVqeINlaniRGWqmFQmlZOKN1TeqJhUpoqTiknlDZWp4o2KSWWq+ITKScUnVKaKTzysta7xsNa6xsNa6xo//LKKk4qTikllqjip+KaKE5U3VN6oeEPlmypOVN5QmSreUDmpmFROVE4qpopvelhrXeNhrXWNh7XWNX74MpWpYlL5l1ROKt5QmSpuUjGpTBVvqHxTxaRyUjFVnKicqEwVk8rf9LDWusbDWusaD2uta/zwoYpJ5ZsqTlR+k8pUcaLyiYoTlZOKk4o3VE4qJpVPVEwqn6g4UTmpmFSmim96WGtd42GtdY2HtdY17A++SOWkYlL5pooTlaniEypTxaRyk4pJ5Y2KT6hMFZPKVHGi8psqJpWp4pse1lrXeFhrXeNhrXWNHz6kMlVMKpPKScUbKpPKGypTxYnKGxWfUJkq3lD5JpWpYlI5qZhUpopJ5Y2KN1Ru8rDWusbDWusaD2uta/zwyyomlTdUpoo3Kj6hclJxojJVnKi8oTJVvFFxonKiclJxUjGpTBUnKicqU8UbKn/Tw1rrGg9rrWs8rLWu8cOHKiaVk4pJ5aTijYpJ5RMVk8qJyonKVDFVTConFW+onFRMFd+kMlWcqEwVb1S8UXGi8pse1lrXeFhrXeNhrXWNHz6k8obKicpvqphUpoqTiknljYpJZao4UfmmihOVqWJSmSpOKt6oeEPlEypTxd/0sNa6xsNa6xoPa61r2B/8IpWTijdUpooTlanib1I5qZhUpopJ5aTim1ROKiaVqeJEZaqYVN6oOFGZKiaVk4pJZar4xMNa6xoPa61rPKy1rmF/8BepTBUnKm9UTConFW+ofKJiUpkqJpWpYlJ5o+JEZaqYVE4qTlSmiknljYpJ5aRiUjmpmFROKj7xsNa6xsNa6xoPa61r/PCXVUwqU8VUcaJyUvEJlaliUjmpmFQ+oTJVTCpTxaQyVXyi4o2KT1S8UfFNFZPKNz2sta7xsNa6xsNa6xr2B1+k8psqPqFyUnGiMlVMKm9UvKFyUnGiMlVMKm9UTCpTxaTyiYo3VE4q3lCZKr7pYa11jYe11jUe1lrXsD/4RSpTxaQyVXyTyjdV/CaVk4pJ5Y2KSeWk4ptUpoo3VN6omFQ+UfGbHtZa13hYa13jYa11jR++TOVEZao4UXmj4qRiUjmp+E0qU8XfVDGpTCrfVPGGylQxqUwVk8pUMalMFZPKpHJS8YmHtdY1HtZa13hYa13jh19WcaIyVUwVN1E5qZhUpoqp4kRlqpgqJpWpYlKZKqaKSeWNijdUpooTlaniDZUTlaliUvlND2utazysta7xsNa6hv3BB1Smiknlb6qYVKaK36TyL1VMKm9UfELljYpJZaqYVKaKSWWqOFH5popPPKy1rvGw1rrGw1rrGvYHv0hlqjhRmSpOVE4q3lB5o2JSOak4UZkqJpW/qWJSOamYVKaKSeWk4kTlpOINlTcqvulhrXWNh7XWNR7WWtf44TIVk8pUcVLxhspUMam8UfGJiknlpOJEZaqYVKaKT6i8UfGGylQxqUwqU8VJxRsqU8UnHtZa13hYa13jYa11DfuD/xCVNyreUJkqvknljYo3VE4q3lB5o2JSmSreUJkq3lA5qThReaPiEw9rrWs8rLWu8bDWusYPX6YyVbyhclIxqbyh8gmVqeJEZaqYVKaKSeWNihOVqeITFScVk8onVKaKSeWkYlKZKt6o+KaHtdY1HtZa13hYa13D/uCLVN6o+ITKv1TxCZWTikllqphUTiomlZOKSeWNihOVk4pPqEwVJypvVHzTw1rrGg9rrWs8rLWu8cOHVN6oeENlqjipOFGZKk5UpopJZaqYVKaKk4pJ5UTlmyomlZOKSeWNik+ovKFys4e11jUe1lrXeFhrXcP+4D9MZao4UXmjYlKZKt5Q+UTFGypTxb+k8omKSWWqeENlqphU3qj4xMNa6xoPa61rPKy1rvHDh1T+pooTlaliqphUpopJZaqYVE4qpoo3VE5UpooTlZOKSeWk4kTlpGJSOVF5Q2WqeKNiUpkqvulhrXWNh7XWNR7WWtf44csqvknlpOJE5RMVJxUnKr+p4o2Km1WcqLxR8YbKv/Sw1rrGw1rrGg9rrWv88MtU3qh4Q2WqOKl4Q+Wk4psqJpVJ5ZtUvknlpOITFZPKpPI3qUwVn3hYa13jYa11jYe11jV++I+rOKmYVD5RMamcVLyhMlVMKlPFpPJGxaTyiYpPqJxUvFHxm1S+6WGtdY2HtdY1HtZa1/jh/5zKJyo+oTJVTCqfUDmpmFSmipOKSeVE5Y2Kk4qbqEwV3/Sw1rrGw1rrGg9rrWv88Msq/qWKSeWkYlI5qThRmVROKiaVNyreUJkqJpWpYlI5qZhU3lCZKr5JZaqYVKaK3/Sw1rrGw1rrGg9rrWv88GUqf5PKScVJxRsVb1ScqEwqJxWTyonKJyomlZOKT1RMKicVk8qJylQxqbyhMlV84mGtdY2HtdY1HtZa17A/WGtd4WGtdY2HtdY1HtZa13hYa13jYa11jYe11jUe1lrXeFhrXeNhrXWNh7XWNR7WWtd4WGtd42GtdY2HtdY1HtZa1/gf/TvC1y8QFAsAAAAASUVORK5CYII=";
    
    return(
        <>
        {openNew&&           
            <div className='w100 h100 posifixedinicio column center z4' >
                <div className='w100 h100 posifixedinicio fundo-opaco z5' onClick={()=>(setOpenNew(false) & setValues(initialValues))}>
                </div>
                <div className='h20 w35 b2 cont-circ3 sombra column center z10 cell-tamanho90'>
                    <div className='w90 h20'>
                        <div className='w100'>
                            {values.idproduto?<h5>Editar {config.pageName}</h5>:<h5>Cadastrar novo(a) {config.pageName}</h5>  }
                        </div>
                        <form onSubmit={onSubmit} autoComplete='off'>
                            <div>
                                <label>Nome:</label>
                                <input type="text"  name="nome"  onChange={onChange} value={values.nome} autoComplete='off'></input>
                            </div>
                            <div>
                                <label>Ingredientes:</label>
                                <input type="text"  name="ingredientes"  onChange={onChange} value={values.ingredientes}></input>
                            </div>
                            <div className='row between w100'>
                                <div className='w30'>
                                    <label>Quantidade:</label>
                                    <input type="text"  name="quantidade"  onChange={onChange} value={values.quantidade}></input>
                                </div>
                                <div className='w30'>
                                    <label>Preco custo:</label>
                                    <input type="text"  name="preco_custo"  onChange={onChange} value={values.preco_custo}></input>
                                </div>
                                <div className='w30'>
                                    <label>Preco final:</label>
                                    <input type="text"  name="preco_final"  onChange={onChange} value={values.preco_final}></input>
                                </div>
                            </div>
                            <div className='row between'>
                                <div className='w49'>
                                    <label>Status:</label>
                                    <input type="text"  name="status"  onChange={onChange} value={values.status}></input>
                                    
                                </div>
                                <div className='w49'>
                                    <label>Validade:</label>
                                    <input type="date"  name="validade"  onChange={onChange} value={values.validade}></input>
                                </div>
                            </div>
                            
                            <div>
                                <label>Categoria:</label>
                                <select name="id_produto_categoria" onChange={onChange} >
                                    <option>Selecione</option>
                                    {optionInput}
                                </select>
                            </div>
                           
                            <div className='cell-margin5'>
                                <input type="submit" value="Cadastrar"></input>
                            </div>
                        </form>
                        <div className='w100 row between'>
                            {values.id_produto?<button className='w25 btn04 cell-tamanho-metade' onClick={()=>exclui(values.id_produto)}>Excluir</button>:<label className='w40'>Sem mais opções</label>}
                            <button onClick={()=>(setOpenNew(false) & setValues(initialValues))} className="w40 ma10b0 btn05">Cancelar</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        }
        
        <section className='h90 column center b15 b30'>
            <AdminHeader props={config.pageName}/>
            <div className="h20 w90 posiabstop row between aligitensstart celular">
                <MenuPainelAdmin/>
                <div className="w70 row between cell-tamanho">
                    <div className="h20 w100 b2 cont-circ3 sombra column center">
                        <h5 className='w90'>Pesquisar {config.pageName}</h5>
                        <form className=' w90 row center' onSubmit={onSubmitSearch} autoComplete='off'>
                            <div className='w80'>
                                <input type="text" name="nome" onChange={onChange}/>
                            </div>
                            <div className='w20'>
                                <input type="submit" value="Pesquisar" style={{backgroundColor: TenancyColor().backgroundColor}}/>
                            </div>
                        </form>
                        <div className='w90 h20 column'>
                            <label className='w100 ma5 fs1p3em'>{config.pageName} Listados(a)</label>
                            <div className='row between w100 h5 cell-none'>
                              
                            </div>
                            {final}
                            <img src={qr} alt='teste'/>
                
                        </div>     
                    </div>
                </div>
            </div>
            <div className="h75 w100 b17">
               
            </div>
        </section>
      </>
    )
}

